export enum TaxResidenceFlags {
    FOREIGNER_LIVE_ABROAD = 1,
    FOREIGNER_LIVE_POLAND = 2,
    POLE = 3,
}
